
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    summary() {
      return this.data.summary
    },
    fields() {
      return this.data.fields
    }
  }
}
